import { createLucideIcon } from "lucide-react";

export const Plus = createLucideIcon(
    "plus",
    [
        [
            "path",
            {
                d: "M3.16602 8H13.8327",
                key: "1cvd9w",
            },
        ],
        [
            "path",
            {
                d: "M8.5 2.66675V13.3334",
                key: "l4tfb5",
            },
        ],
    ],
);
